import {
  CREATE_INVOICE_DOWNLOAD_JOB_INITIATED,
  CREATE_INVOICE_DOWNLOAD_JOB_LOADED,
  CREATE_INVOICE_DOWNLOAD_JOB_FAILED,
  LOAD_INVOICE_DOWNLOAD_JOBS_INITIATED,
  LOAD_INVOICE_DOWNLOAD_JOBS_LOADED,
  LOAD_INVOICE_DOWNLOAD_JOBS_FAILED,
  REGENERATE_INVOICE_SHEET_INITIATED,
  REGENERATE_INVOICE_SHEET_LOADED,
  REGENERATE_INVOICE_SHEET_FAILED,
} from "../actions/InvoiceDownloadJobsAction";

const initialState = {
  listdata: [],
  pagination: { total: 0, totalPages: 1, page: 1 },
  loading: false,
  error: null,
  creating: false,
  regenerating: {},
};

const InvoiceDownloadJobsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_INVOICE_DOWNLOAD_JOB_INITIATED:
      return { ...state, creating: true };
    case CREATE_INVOICE_DOWNLOAD_JOB_LOADED:
    case CREATE_INVOICE_DOWNLOAD_JOB_FAILED:
      return { ...state, creating: false };

    case LOAD_INVOICE_DOWNLOAD_JOBS_INITIATED:
      return { ...state, loading: true, error: null };
    case LOAD_INVOICE_DOWNLOAD_JOBS_LOADED:
      return { ...state, loading: false, listdata: action.payload.data, pagination: action.payload.pagination };
    case LOAD_INVOICE_DOWNLOAD_JOBS_FAILED:
      return { ...state, loading: false, error: action.payload };

    case REGENERATE_INVOICE_SHEET_INITIATED:
      return { ...state, regenerating: { ...state.regenerating, [action.payload]: true } };
    case REGENERATE_INVOICE_SHEET_FAILED:
      return { ...state, regenerating: { ...state.regenerating, [action.payload]: false } };
    case REGENERATE_INVOICE_SHEET_LOADED:
      return {
        ...state,
        regenerating: { ...state.regenerating, [action.payload.id]: false },
        listdata: state.listdata.map((j) =>
          j.id === action.payload.id ? { ...j, invoiceSheetUrl: action.payload.invoiceSheetUrl } : j
        ),
      };

    default:
      return state;
  }
};

export default InvoiceDownloadJobsReducer;
